import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HTMLCode from "components/common/HTMLCode";
import If from "components/common/If";
import PropertyView from "components/common/views/PropertyView";
import React from "react";
import PropertyViewValue, { AppPropertyType } from "./PropertyViewValue";

type ItemViewPropertyViewType = 'compact' | 'default';

type ItemViewPropertyViewDataHideType = {
    hide?: ItemViewPropertyViewType  | boolean | (() => boolean),
    name: string,
    className?: {
        compact?: string,
        default?: string
    } | string,
}

export type ItemViewPropertyViewDataItemType = ItemViewPropertyViewDataHideType & {
    label?: string,
    value: any,
    icon?: IconDefinition,
    propertyType?: AppPropertyType;
    textSize?: 'text-sm' | 'text-lg' | 'text-md'
}

export type ItemViewPropertyViewDataListType = ItemViewPropertyViewDataHideType & {
    items: ItemViewPropertyViewDataItemType[]
}


export type ItemViewPropsType = {
    model: ItemViewPropertyViewDataListType[],
    view: ItemViewPropertyViewType,
    name: string,
    className?: string
}

const ItemView = (props: ItemViewPropsType) => {
    const getItemClass = (item: ItemViewPropertyViewDataItemType) => {
        let className = [
            'my-auto'
        ];
        if (props.view === 'default' && item.propertyType !== 'note') {
            className.push('px-2');
        }

        if(typeof item.className === 'string') className.push(item.className);
        if(typeof item.className === 'object' && item.className[props.view]) {
            className.push(item.className[props.view]!);
        }

        return className.join(' ');
    }

    const getClass = (item: ItemViewPropertyViewDataListType, itemCount: number) => {
        if (item.className) {
            if (typeof item.className === 'string') return item.className;
            if (item.className && item.className[props.view]) return item.className[props.view];
        }
        
        if (props.view === 'default') return 'border-b theme-border last:border-b-0';
        else return `grid text-center grid-cols-` + (itemCount > 3 ? 3 : itemCount);
    }

    const renderSectionItems = (item: ItemViewPropertyViewDataListType) => {
        return item.items.map(i => {
            if (isHidden(i)) return <React.Fragment key={`${props.name}-${item.name}-${i.name}-field`}></React.Fragment>;
            const labelClassName = i.propertyType === 'note' ? 'px-2' : ''
            return (
                <div  key={`${props.name}-${item.name}-${i.name}-field`} className={getItemClass(i)}>
                    <PropertyView label={props.view === 'default' ? i.label : ''} labelClassName={labelClassName} textSize={i.textSize} propertyType={i.propertyType}>
                    <>
                        <If condition={props.view === 'compact' && i.icon}>
                            <FontAwesomeIcon icon={i.icon!} />
                            <HTMLCode />
                        </If>
                        <PropertyViewValue value={i.value} propertyType={i.propertyType}  />
                    </>
                    </PropertyView>
                </div>
            )
        })
    }

    const renderSections = (): React.ReactNode | React.ReactNode[] => {
        const sectionItems = props.model.filter(i => !isHidden(i));
        return sectionItems.map(i => {
            return (
                <div key={props.name + "-" + i.name + "-section"}
                    className={getClass(i, i.items.length) + " col-span-3"}
                >
                        {renderSectionItems(i)}
                </div>
            );
        });
    }

    const isHidden = (i: ItemViewPropertyViewDataHideType) : boolean => {
        if(!i.hide) return false;
        if(typeof i.hide === 'function') return i.hide();
        if(typeof i.hide === 'boolean') return i.hide;
        return i.hide === props.view;
    }

    return (
        <div className={props.className}>
            {renderSections()}
        </div>
    )
};

export default ItemView;
